// S12 — reusable breadcrumb that walks an entity's ancestor chain.
// Each segment links back to /entities?selected=<id>.
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "lucide-react";

import { useEntityAncestors } from "@/api/entities";

interface Props {
  entityId: string;
  className?: string;
}

export function EntityBreadcrumb({ entityId, className }: Props) {
  const { data: chain } = useEntityAncestors(entityId);
  if (!chain || chain.length === 0) return null;
  return (
    <nav
      aria-label="entity-breadcrumb"
      className={className ?? "flex items-center gap-1 text-xs text-muted-foreground"}
    >
      {chain.map((e, i) => (
        <span key={e.id} className="flex items-center gap-1">
          {i > 0 && <ChevronRightIcon className="h-3 w-3 text-muted-foreground/60" />}
          <Link
            to={`/entities?selected=${e.id}`}
            className="hover:text-foreground hover:underline"
          >
            {e.name}
          </Link>
        </span>
      ))}
    </nav>
  );
}
